import { Injectable } from '@angular/core';
import { QuestionBase } from 'core/components';

@Injectable()
export class UtilsQuestionsService {
  constructor() {}

  /**
   * Find the index of a question of the list of questions
   * @param questionKey key of the question to find
   * @param questions list of questions
   * @returns the index found of the question
   */
  public findQuestionIndex(questionKey: string, questions: any[]) {
    if (questionKey && questions) {
      return questions.findIndex((question) => question.key === questionKey);
    }
    return -1;
  }

  /**
   * Find a question of the list of questions
   * @param questionKey key of the question to find
   * @param questions list of questions
   * @returns the found question
   */
  public findQuestion(questionKey: string, questions: QuestionBase<any>[]): QuestionBase<any> {
    let found: QuestionBase<any> = null;
    if (questionKey && questions) {
      questions.some((question) => {
        if (question.key === questionKey) {
          found = question;
        } else if (question.childQuestions) {
          found = this.findQuestion(questionKey, question.childQuestions);
        }
        return !!found;
      });
    }
    return found;
  }

  /**
   * Find a child question of the parent question
   * @param questionKey
   * @param questions
   * @return object with the child questions and the parent index
   * @private
   */
  public findQuestionNestedIndex(questionKey: string, questions: any[]): { childQuestions: any; childIndex: number } {
    let questionFound = null;
    questions.find((quest: any) =>
      quest.childQuestions.some((question: any, i: number) => {
        if (question.key === questionKey) {
          questionFound = { childQuestions: quest.childQuestions, childIndex: i };
          return questionFound;
        } else if (question.childQuestions.length > 0) {
          questionFound = this.findQuestionNestedIndex(questionKey, question.childQuestions);
        }
      })
    );
    return questionFound;
  }
}
